import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="w-full max-w-sm space-y-5">
        <h1 className="font-heading text-3xl font-extrabold uppercase">Obnova hesla</h1>
        {sent ? (
          <div className="rounded-lg border border-emerald-500/40 bg-emerald-500/10 px-4 py-3 text-sm" data-testid="forgot-success">
            Ak je email registrovaný, poslali sme naň odkaz na obnovu hesla.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-muted-foreground">Zadajte email a pošleme vám odkaz na obnovu.</p>
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="min-h-[48px]" data-testid="forgot-email-input" />
            </div>
            {error && <div className="text-sm text-destructive">{error}</div>}
            <Button type="submit" className="min-h-[48px] w-full" disabled={loading} data-testid="forgot-submit-button">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Poslať odkaz"}
            </Button>
          </form>
        )}
        <Link to="/login" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"><ArrowLeft className="h-4 w-4" /> Späť na prihlásenie</Link>
      </div>
    </div>
  );
}
